import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { renderComponent } from '../../helpers/component-renderer';

const FaqComponent = ({ question, answer }) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography variant='body1'>{question}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      {answer.map((answerPart, index) => renderComponent(answerPart, index))}
    </AccordionDetails>
  </Accordion>
);

const FaqList = ({ items }) => (
  <Box sx={{ maxWidth: '672px', mx: 'auto', mt: 2 }}>
    {items.map((item, index) => (
      <FaqComponent {...item} key={index} />
    ))}
  </Box>
);

export default FaqList;
